import React, { useState, useEffect } from 'react'
import getCurrentUser from '../../utils/getCurrentUser'
import CaptureHawb from '../CaptureHawb'
import CaptureAWB from './CaptureAWB'
import AWBInputBox from './AWBInputForm'
import Declaration from './Declaration'
import { useTranslation } from 'react-i18next'
import { SelectButton } from 'primereact/selectbutton'
import {
    validateAWBDocNo,
    validateAWBPrefix,
    hasError,
    removeError,
} from './captureAwbUtils'
import {
    validateAWB,
    validateHAWB,
    validateHawbForm,
    isHSCodeMandatory,
} from '../CaptureHawb/CaptureHawbValidations'
import { getShippingItems } from '../../services/searchPanelServices'
import { getAWBDetails } from '../SearchPanel/templateUtils'
import { getValidationRule } from '../../services/quoteServices'
import { getRecentBooking } from '../../services/templateService'
import { v4 as uuidv4 } from 'uuid'
import Messages from '../../constants/Messages'
import pageNames from '../../constants/pageNames'
import { addError, pushPageData } from '../../utils/analytics'
import { PAGE_PRIMARY_CATEGORY, PAGE_SUB_CATEGORY1, CAPTURE_PAGE_SUB_CATEGORY2 } from '../../constants/index'
import { Alert } from '../../common/Alert'
import SubHeader from '../../common/Resusable/SubHeader/SubHeader'
import HAWBInputBox from '../CaptureHawb/HAWBInputForm'
import {
    deleteHAWBDetails,
    findHAWBDetails,
    saveHAWBDetails,
    getHawbMassUploadDetails,
    getHawbMassUploadRecords,
    resubmitHawbFailedRecord,
} from '../../services/dataCaptureService'
import { HawbFailedEditInitialState, mapAWBResponse, mapHawbFailedRecordResponse, mapHawbResponse } from '../CaptureHawb/HawbResponseMapper'
import LoadingIndicator from '../LoadingIndicator'
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../redux/actions/masterDataActions";
const CaptureAWBRoot = ({ showErrorPopup }) => {
    const { t, i18n } = useTranslation(['labels', 'errors'])
    const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
    const userDetails = getCurrentUser()
    const [showTC, setShowTC] = useState(
        userDetails ? userDetails.dataCaptureTnCFlag === false : true
    )
    const [shipmentPrefix, setShipmentPrefix] = useState(null)
    const [masterDocumentNumber, setMasterDocumentNumber] = useState(null)
    const [selectedMenuItem, setSelectedMenuItem] = useState('awb')

    // AWB input state
    const [awbPrefix, setAwbPrefix] = useState('607')
    const [awbNo, setAwbNo] = useState('')
    const [error, setError] = useState({})
    const [awbDetails, setAwbDetails] = useState(null)
    const [alertMessage, setAlertMessage] = useState('')
    const [status, setStatus] = useState(null)
    const [shippingItems, setShippingItems] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [chargeableWeight, setChargeableWeight] = useState(null)
    const [accordionsActive, setAccordionsActive] = useState([])
    const [initialLoading, setInitialLoading] = useState(false)
    const [enableButtons, setEnableButtons] = useState(false)
    const [notificationType, setNotificationType] = useState(null)
    const [notificationMessage, setNotificationMessage] = useState('')
    const [popupDetails, setPopupDetails] = useState(null)
    const [bookingDetails, setBookingDetails] = useState({})
    const [validationRule, setValidationRule] = useState([])

const [hawbDetails, setHawbDetails] = useState(null);
const [hawbError, setHawbError] = useState({});
const [hawbInput, setHawbInput] = useState({
    shipmentPrefix: '607',
    masterDocumentNumber: ''
});
const [showHawbDetails, setShowHawbDetails] = useState(false);
const [hawbTrigger, setHawbTrigger] = useState(0);
const masterData = useSelector(state => state?.masterData);
    const dispatch = useDispatch();


useEffect(() => {
    if (showHawbDetails) {
        setIsLoading(true);
    }
}, [showHawbDetails]);


    useEffect(() => {
        (async () => {
            try {
                // let items = await getShippingItems()
                let items = [];
                if (masterData?.shippingItemsMaster && masterData.shippingItemsMaster.length > 0) {
                    // productList = masterData.productsMaster;
                    items = [...masterData.shippingItemsMaster];
                } else {
                    items = await getShippingItems();
                    if (items && items.length > 0) {
                        const masterDataPayload = {
                            shippingItemsMaster: items
                        };
                        dispatch(setMasterDataDetails(masterDataPayload));
                        items = [...items];
                    }
                }
                if (items) {
                    items = items.sort((a, b) => a.description.localeCompare(b.description))
                }
                setShippingItems(items)
                pushPageData(
                    pageNames.AWB_DETAILS,
                    PAGE_PRIMARY_CATEGORY.E_SERVICES,
                    PAGE_SUB_CATEGORY1.CAPTURE,
                    CAPTURE_PAGE_SUB_CATEGORY2.CAPTURE_AWB,
                )
            } catch (err) {
                addError(
                    'SHIPPING_ITEM_API_ERROR',
                    'Sorry, Shipping Details could not retrive now .Please try again later'
                )
                pushPageData(
                    pageNames.AWB_DETAILS,
                    PAGE_PRIMARY_CATEGORY.E_SERVICES,
                    PAGE_SUB_CATEGORY1.CAPTURE,
                    CAPTURE_PAGE_SUB_CATEGORY2.CAPTURE_AWB,
                )
            }
        })()
    }, [])

    // Handler for SelectButton
    const tabOptions = [
        { label: t('CAPTURE_AWB.AWB_SCREEN'), value: 'awb' },
        { label: t('COMMON.HOUSE_AWB'), value: 'hawb' }
    ]

    const handleSelectChange = (e) => {
        setSelectedMenuItem(e.value)
        setShipmentPrefix(null)
        setMasterDocumentNumber(null)
        setAwbDetails(null)
        setAwbPrefix('607')
        setAwbNo('')
        setError({})
        setAlertMessage('')
        setStatus(null)
        setHawbInput({
            shipmentPrefix: '607',
            masterDocumentNumber: ''
        })
        setHawbError({})
        setHawbDetails(null)
        setShowHawbDetails(false);
    }

    // Helper for getAwb object
    const getAwb = () => ({
        shipmentPrefix: awbPrefix,
        masterDocumentNumber: awbNo
    })


    const handleGetAwb = async () => {
        setIsLoading(true);
        setInitialLoading(true);
        
            setAwbDetails(null);
            setError({});
            setAlertMessage('');
            setStatus(null);
            setChargeableWeight(null);
            setShipmentPrefix(null);
            setMasterDocumentNumber(null);
            setAccordionsActive([]);

            if (
                validateAWBDocNo(awbNo, setError) &&
                validateAWBPrefix(awbPrefix, setError)
            ) {

                try {
                    const data = await getAWBDetails(
                        shippingItems,
                        awbPrefix + awbNo,
                        setIsLoading,
                        false
                    )
            
                    if (data && !data.errorDescription) {

                        const fullPhone = data?.shipperDetails?.telephoneNo || '';
                        const [countryCode, localPhone] = fullPhone.includes('-') ? fullPhone.split('-') : [null, fullPhone];

                        const updatedAwbDetails = {
                            ...data,
                            shipperDetails: {
                                ...data.shipperDetails,
                                telephoneNo: localPhone,
                                phContryCode: { code: countryCode }
                            },
                            consigneeDetails: {
                                ...data.consigneeDetails,
                                ...(data?.consigneeDetails?.telephoneNo?.includes('-')
                                    ? {
                                        telephoneNo: data.consigneeDetails.telephoneNo.split('-')[1],
                                        phContryCode: { code: data.consigneeDetails.telephoneNo.split('-')[0] }
                                    }
                                    : {})
                            },

                            notifyList:{
                                ...data.notifyList,
                                ...data.notifyList?.notifyOther?.telephoneNo?.includes('-')?{
                                    telephoneNo: data.notifyList?.notifyOther?.telephoneNo.split('-')[1],
                                    phContryCode: { code: data.notifyList?.notifyOther?.telephoneNo.split('-')[0] } 
                                }
                                :{}
                            }
                        };

                        console.log('updatedAwbDetails:', updatedAwbDetails);
                       
                        setAwbDetails(updatedAwbDetails)
                        setChargeableWeight(data.chargeableWeight)
                        if (
                            data &&
                            data.awbExecutionDetails &&
                            data.awbExecutionDetails.issuedBy &&
                            data.awbExecutionDetails.issuedPlace
                        ) {
                            setEnableButtons(true)
                        }
                        // Fetch MAWB validation rule
                        const fetchMawbValidationRule = async () => {
                            try {
                                const captureType = "MAWB"
                                const validationResponse = await getValidationRule(captureType)
                                setValidationRule(validationResponse)
                                const enabledFlags = validationResponse.map(item => item?.enabled)
                                return enabledFlags.includes(true)
                            } catch (error) {
                                console.error('Failed to fetch validationRules', error)
                            }
                        }
                        const isMawbValid = await fetchMawbValidationRule()
                        if (isMawbValid) {
                            // Fetch booking data
                            const fetchBookingData = async () => {
                                try {
                                    const userDetails = getCurrentUser()
                                    // const request = {
                                    //     requestId: uuidv4(),
                                    //     shipmentIdentifier: getAwb(),
                                    //     ubrNumber: null,
                                    //     agentCode: userDetails ? userDetails.agentCode : null,
                                    // }
                                    const request = {
                                        messageHeader: {
                                            messageType: "D",
                                            sourceSystem: "PORTAL",
                                            userId: userDetails?.userId || "TESTUSER",
                                            
                                        },
                                        requestData: {
                                            requestID: uuidv4(),
                                            shipmentIdentifier: getAwb(),
                                            ubrNumber: null,
                                            agentCode: userDetails ? userDetails.agentCode : null,
                                        }
                                    };
                                    const bookingDetailsResponse = await getRecentBooking(request)
                                    setBookingDetails(bookingDetailsResponse)
                                } catch (error) {
                                    console.error('Failed to fetch data', error)
                                }
                            }
                            await fetchBookingData()
                        }
                        setStatus(true)
                        setAlertMessage('')
                    } else if (data && data.errorDescription) {
                        setStatus(false)
                        setAlertMessage(data.errorDescription)
                        addError('GET_AWB_API_ERROR', data.errorDescription)
                    } else {
                        setStatus(false)
                        setAlertMessage(Messages.AWB_NOT_FOUND)
                        addError(
                            Messages.AWB_NOT_FOUND,
                            i18n.getResource('en', 'errors', Messages.AWB_NOT_FOUND)
                        )
                    }
                } finally {
                    setIsLoading(false)
                }
            } else {
                setStatus(false)
                setAlertMessage('Invalid AWB details')
            }

    };


    const handleAlertClose = () => {
        setStatus(false)
        setAlertMessage('')
        setNotificationMessage('')
        setNotificationType(null)
    }

    const closeErrorPopup = () => {
        setPopupDetails(null)
    }

const handleGetHAWB = () => {
    setIsLoading(true); // Show loader immediately
    let isAWBValid = validateAWB(
        hawbInput.masterDocumentNumber,
        'masterDocumentNumber',
        setHawbError
    );
    let isAwWBPrefixValid = validateAWBPrefix(
        hawbInput.shipmentPrefix,
        setHawbError
    );
    if (isAWBValid && isAwWBPrefixValid) {
        setShowHawbDetails(false); // Reset first to force re-render
        setTimeout(() => {
            setShowHawbDetails(true); // Show the details screen
            setHawbTrigger(prev => prev + 1);
        }, 0);
       
    } else {
        setIsLoading(false); // Hide loader if validation fails
    }
};

    return userDetails && Object.keys(userDetails).length !== 0 ? (
	
    <div className='cargo-portal-container portal-tabs tabs-data-capture data-capture-content'>
         {isLoading && <LoadingIndicator />}
        {!showTC ? (
            <>
			    <div className={`data-capture-search-section ${isRTL ? 'rtl' : ''}`}>
					{alertMessage !== '' && status !== null && (
						<Alert
							isError={!status}
							showAlert={true}
							message={t(alertMessage, { ns: 'errors' })}
							setTimeout={true}
							onAlertClose={handleAlertClose}
							timeOut={12000}
						/>
					)}
                        <div className='data-capture-box'>
                            <div className='portal-row'>
                                <div className='portal-col'>
                                    <label className='page-heading mt-0'>
                                        {t('COMMON.DATA_CAPTURE')}
                                    </label>
                                </div>
                            </div>
                            <div className='capture-awb-input-section'>
                                <div className='portal-row capture-faqs-row'>
                                    <div className='portal-col capture-faqs d-flex align-items-left'>
                                        <span>
                                          {t('COMMON.YOU_CAN_CHECK')}
                                            <a href='/PLACI-QuickHelp.pdf' className='link help-link mx-2' target='_blank'>Etihad-placi</a>
                                           {t('COMMON.QUICK_HELP')}
                                        </span>
                                    </div>
                                </div>
                                <div className='form-row'>
                                    <div className='awb-menu'>
                                        <SelectButton
                                            className='common-select-button mutliple-booking-select-button'
                                            value={selectedMenuItem}
                                            options={tabOptions}
                                            onChange={handleSelectChange}
                                        />
                                    </div>
                                </div>
                                {selectedMenuItem === 'awb' && (
                                    <AWBInputBox
                                        t={t}
                                        awbPrefix={awbPrefix}
                                        setAwbPrefix={setAwbPrefix}
                                        awbNo={awbNo}
                                        setAwbNo={setAwbNo}
                                        error={error}
                                        validateAWBPrefix={(val) => validateAWBPrefix(val, setError)}
                                        validateAWBDocNo={(val) => validateAWBDocNo(val, setError)}
                                        hasError={hasError}
                                        removeError={(e) => removeError(e, setError)}
                                        handleGetAwb={handleGetAwb}
                                    />
                                )}
                                {selectedMenuItem === 'hawb' && (
                                    <HAWBInputBox
                                        t={t}
                                        error={hawbError}
                                        setError={setHawbError}
                                        awbDetails={hawbInput}
                                        setAwbDetails={setHawbInput}
                                        getHAWBDetails={handleGetHAWB}
                                        setIsLoading={setIsLoading}
                                        isLoading={isLoading}
                                    />
                                )}
                            </div>
                       </div> 
			  </div>	
                {/* Result component outside the data-capture-box */}
                {selectedMenuItem === 'awb' && awbDetails && (
                     <div className={`awb-result-box ${isRTL ? 'rtl' : ''}`}>
                        <CaptureAWB
                            t={t}
                            alertMessage={alertMessage}
                            status={status}
                            handleAlertClose={handleAlertClose}
                            awbDetails={awbDetails}
                            shippingItems={shippingItems}
                            setAwbDetails={setAwbDetails}
                            setShipmentPrefix={setShipmentPrefix}
                            setMasterDocumentNumber={setMasterDocumentNumber}
                            setError={setError}
                            error={error}
                            setIsLoading={setIsLoading}
                            setStatus={setStatus}
                            setAlertMessage={setAlertMessage}
                            chargeableWeight={chargeableWeight}
                            handleTabChange={() => {}}
                            accordionsActive={accordionsActive}
                            setAccordionsActive={setAccordionsActive}
                            initialLoading={initialLoading}
                            setInitialLoading={setInitialLoading}
                            enableButtons={enableButtons}
                            setEnableButtons={setEnableButtons}
                            setNotificationMessage={setNotificationMessage}
                            setNotificationType={setNotificationType}
                            setPopupDetails={setPopupDetails}
                            bookingDetails={bookingDetails}
                            validationRule={validationRule}
                            popupDetails={popupDetails}
                            closeErrorPopup={closeErrorPopup}
                            isLoading={isLoading}
							setSelectedMenuItem={setSelectedMenuItem}
                            setHawbInput={setHawbInput}
                        />
                    </div>
                )}
                    {selectedMenuItem === 'hawb' && showHawbDetails && (
                        <div className={`awb-result-box ${isRTL ? 'rtl' : ''}`}>
                            <CaptureHawb
                                shipmentPrefix={hawbInput.shipmentPrefix}
                                masterDocumentNumber={hawbInput.masterDocumentNumber}
                                setAlertMessage={setAlertMessage} 
                                setSuccess={setStatus} 
                                alertMessage={alertMessage}   
                                success={status} 
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                            />
                        </div>
                    )}
            </>
        ) : (
            <Declaration setShowTC={setShowTC} />
        )}
    </div>
) : null
}

export default CaptureAWBRoot


// import { TabPanel, TabView } from 'primereact/tabview'
// import React, { useState } from 'react'
// import getCurrentUser from '../../utils/getCurrentUser'
// import CaptureHawb from '../CaptureHawb'
// import CaptureAWB from './CaptureAWB'
// import Declaration from './Declaration'
// import { useTranslation } from 'react-i18next'
// import { SelectButton } from 'primereact/selectbutton'
// const CaptureAWBRoot = ({ showErrorPopup }) => {
// 	//for multilingual
// 	const { t } = useTranslation(['labels'])

// 	const userDetails = getCurrentUser()
// 	const [showTC, setShowTC] = useState(
// 		userDetails
// 			? userDetails.dataCaptureTnCFlag === false
// 			: true
// 	)
// 	const [activeIndex, setActiveIndex] = useState(0)
// 	const [shipmentPrefix, setShipmentPrefix] = useState(null)
// 	const [masterDocumentNumber, setMasterDocumentNumber] = useState(null)

// 	const handleTabChange = (index) => {
// 		setActiveIndex(index)
// 		if (index === 0) {
// 			setShipmentPrefix(null)
// 			setMasterDocumentNumber(null)
// 		}
// 	}

// 	const tabOptions = [
//         { label: t('CAPTURE_AWB.AWB_SCREEN'), value: 'awb' },
//         { label: t('COMMON.HOUSE_AWB'), value: 'hawb' }
//     ]
//     const [selectedMenuItem, setSelectedMenuItem] = useState('awb')

//     const handleSelectChange = (e) => {
//         setSelectedMenuItem(e.value)
//         setActiveIndex(e.value === 'awb' ? 0 : 1)
//         if (e.value === 'awb') {
//             setShipmentPrefix(null)
//             setMasterDocumentNumber(null)
//         }
//     }

// 	return userDetails && Object.keys(userDetails).length !== 0 ? (
// 		<>
// 			<div className='container-lg cargo-portal-container portal-tabs tabs-data-capture'>
// 				{!showTC ? (
// 					<div className='data-capture'>
// 						<div className='portal-row'>
// 							<div className='portal-col'>
// 								<h3 className='page-heading mt-0'>
// 									{t('COMMON.DATA_CAPTURE')}
// 								</h3>
// 							</div>
// 						</div>
// 						<div className='portal-row capture-faqs-row'>
// 							<div className='portal-col capture-faqs d-flex align-items-left'>
// 								<span>You can check our</span>
// 								<a href='/PLACI-QuickHelp.pdf' className='link help-link mx-2' target='_blank'>Etihad-placi</a>
// 								<span>for a quick help</span>
// 							</div>
// 						</div>
// 						{/* <TabView
// 							activeIndex={activeIndex}
// 							onTabChange={(e) => handleTabChange(e.index)}
// 						>
// 							<TabPanel
// 								header={t('CAPTURE_AWB.AWB_SCREEN')}
// 								headerClassName='awb-capture no-icon'
// 							>
// 								<CaptureAWB
// 									setShipmentPrefix={setShipmentPrefix}
// 									setMasterDocumentNumber={setMasterDocumentNumber}
// 									handleTabChange={handleTabChange}
// 								/>
// 							</TabPanel>
// 							<TabPanel
// 								header={t('COMMON.HOUSE_AWB')}
// 								headerClassName='hawb-capture no-icon'
// 							>
// 								<CaptureHawb
// 									shipmentPrefix={shipmentPrefix}
// 									masterDocumentNumber={masterDocumentNumber}
// 								/>
// 							</TabPanel>
// 						</TabView> */}
// 						<div className='form-row mt-3 mb-3'>
//                             <div className='col-12'>
//                                 <SelectButton
//                                     className='mutliple-booking-select-button'
//                                     value={selectedMenuItem}
//                                     options={tabOptions}
//                                     onChange={handleSelectChange}
//                                 />
//                             </div>
//                         </div>
//                         {selectedMenuItem === 'awb' && (
//                             <CaptureAWB
//                                 setShipmentPrefix={setShipmentPrefix}
//                                 setMasterDocumentNumber={setMasterDocumentNumber}
//                                 handleTabChange={handleTabChange}
//                             />
//                         )}
//                         {selectedMenuItem === 'hawb' && (
//                             <CaptureHawb
//                                 shipmentPrefix={shipmentPrefix}
//                                 masterDocumentNumber={masterDocumentNumber}
//                             />
//                         )}
//                     </div>
		
// 				) : (
// 					<Declaration setShowTC={setShowTC} />
// 				)}
// 			</div>
// 		</>
// 	) : (
// 		<></>
// 	)
// }

// export default CaptureAWBRoot
